module.exports = __webpack_public_path__ + "static/media/terms_and_use.c1548d34.pdf";